<template>
  <div>
    <el-dialog title="选择规格" :visible.sync="visible" width="20%" center :close-on-click-moda="false">
      <el-form size="mini" ref="formName" label-width="110px"
               style="margin:0 auto;">
        <el-form-item label="商品规格:" prop="goodsPriceId">
          <el-select v-model="saveActivityGoodsModel.goodsPriceId" placeholder="商品规格">
            <el-option
                v-for="item in goodsPrice"
                :key="item.id"
                :label="item.name+' (原价：'+item.price+')'"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="saveAddActivity" size="small">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "order-detail",
  data: function () {
    return {
      visible: false,
      goodsPrice: [],
      dynamicPath: config.dynamicResourcePath,
      saveActivityGoodsModel: {},
    };
  },
  methods: {
    open({activityId, goodsId}) {
      if (activityId && goodsId) {
        this.visible = true
        this.saveActivityGoodsModel.goodsId = goodsId
        this.saveActivityGoodsModel.activityId = activityId
        this.findGoodsPrice()
      } else {
        console.log("...")
      }
    },
    close() {
      this.visible = false;
    },

    saveAddActivity() {
      let _this = this;
      _this.$common.my_ajax({
        url: 'activityRelation/saveActivityRelation',
        data: _this.saveActivityGoodsModel,
        success: function (response) {
          _this.$message({
            message: '添加成功',
            type: 'success',
            duration: 1000,
            onClose() {
              _this.visible = false
            }
          });
        }
      });
    },

    findGoodsPrice() {
      const _this = this;
      _this.goodsPrice = [];
      _this.$common.my_ajax({
        url: 'goodsPrice/pageGoodsPrice',
        data: {
          goodsId: _this.saveActivityGoodsModel.goodsId
        },
        success: function (response) {
          _this.goodsPrice = response.items;
        }
      });
    }
  },
  watch: {
    visible: function (val, oldVal) {
      if (!val) {
        Object.assign(this.$data, this.$options.data())
      }
      console.log(this.$data);
    }
  }
}
</script>

<style>

</style>
